import TopRelationshipsReducer from './TopRelationshipsReducer';

export default from './TopRelationshipsContainer';
export const TopRelationshipsReducers = {
  TopRelationshipsReducer,
};
